export function toStudyDefinitionSource(source) {
    return typeof source === 'string'
        ? source.trim()
        : {
            id: source.id,
            title: source.title,
            revision: source.revision,
        };
}
//# sourceMappingURL=study-definition-source.js.map